import { useState } from 'react';
import { useLeadsListsByCountry } from '@/hooks/smswiser/core/useSMSWiser';

export function useListSelection(countryKey: string, initial: number[] = []) {
  const lists = useLeadsListsByCountry(countryKey);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState<number[]>(initial);
  const needle = query.trim().toLowerCase();
  const visible = (lists.data ?? []).filter((list) =>
    `${list.name} ${list.id}`.toLowerCase().includes(needle),
  );
  const toggle = (id: number) => setSelected((ids) =>
    ids.includes(id) ? ids.filter((value) => value !== id) : [...ids, id],
  );
  const missing = selected.filter((id) => !lists.data?.some((list) => list.id === id));

  const clear = () => setSelected([]);
  return { lists, query, setQuery, selected, visible, toggle, missing, clear };
}
